// extracted by mini-css-extract-plugin
export default {"OrderDetailsPage":"OrderDetailsPage_OrderDetailsPage__GJrFT"};